<template>
  <div class="content">
    <div class="content_title">
      Создание пользователя клиента
    </div>
    <div class="main row">
      <div class="form-row">
        <div class="form-field">
          <b>Данные лица</b>
        </div>
        <div class="form-field">
          <label for="reg-surname-input">Фамилия:</label>
          <input id="reg-surname-input" v-model="names.surname" type="text" />
        </div>
        <div class="form-field">
          <label for="reg-name-input">Имя:</label>
          <input id="reg-name-input" v-model="names.name" type="text" />
        </div>
        <div class="form-field">
          <label for="reg-second-name-input">Отчество:</label>
          <input
            id="reg-second-name-input"
            v-model="names.lastname"
            type="text"
          />
        </div>
        <div class="form-field">
          <label for="reg-phone-input">Телефон:</label>
          <input id="reg-phone-input" v-model="regData.phone" type="text" />
        </div>
        <div class="form-field">
          <label for="reg-email-input">Email:</label>
          <input id="reg-email-input" v-model="regData.email" type="text" />
        </div>
      </div>
      <div class="form-row">
        <div class="form-field">
          <b>Данные организации</b>
        </div>
        <div class="form-field">
          <label for="reg-org-name-input">Название организации:</label>
          <input
            id="reg-org-name-input"
            v-model="regData.orgName"
            type="text"
          />
        </div>
        <div class="form-field">
          <label for="reg-org-inn-input">ИНН организации:</label>
          <input id="reg-org-inn-input" v-model="regData.orgInn" type="text" />
        </div>
        <div class="form-field">
          <label for="reg-org-type">Тип организации:</label>
          <select id="reg-org-type" v-model="regData.orgType">
            <option value="an">Агентство недвижимости</option>
            <option value="uk">Управляющая компания</option>
            <option value="snt">СНТ/ТСЖ</option>
          </select>
        </div>
      </div>
    </div>
    <div class="main row">
      <div class="form-row">
        <div class="form-field">
          <button @click="sendRegisterData">Создать и сохранить</button>
        </div>
      </div>
      <div class="form-row" v-show="password">
        <div class="form-field">
          <button @click="passwordToClipboard">
            Копировать пароль
          </button>
        </div>
      </div>
      <div class="form-row">
        <div class="form-field">
          <button>
            Продолжить
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";
//V*(Fo6
export default {
  name: "RegisterUK",
  props: {
    updateList: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      url: config.backend_url,
      names: {
        name: null,
        surname: null,
        lastname: null
      },
      regData: {
        fio: null,
        phone: null,
        email: null,
        orgName: null,
        orgInn: null,
        orgType: null
      },
      password: null,
      phoneKey: null,
      userId: false,
      token: false,
      info: false
    };
  },
  computed: {},
  watch: {},
  methods: {
    sendRegisterData: function() {
      let self = this;
      if (
        self.names.name !== null &&
        self.names.surname !== null &&
        self.names.lastname !== null &&
        self.regData.orgName !== null &&
        self.regData.orgInn !== null &&
        self.regData.orgType !== null &&
        self.regData.phone !== null &&
        self.regData.email !== null
      ) {
        self.regData.fio =
          self.names.surname +
          " " +
          self.names.name +
          " " +
          self.names.lastname;
        this.$store
          .dispatch("query/sendRequest", {
            url: self.url + "users/add-company/",
            data: self.regData,
            method: "POST"
          })
          .then(function(response) {
            let data = response.data;
            console.log(data);
            if (!data.error) {
              self.userId = data.userId;
              self.password = data.temporaryPassword;
            }
          });
      } else {
        alert("Необходимо заполнить все поля");
      }
    },
    passwordToClipboard: function(e) {
      var type = "text/plain";
      var blob = new Blob([this.password], { type });
      // eslint-disable-next-line no-undef
      var data = [new ClipboardItem({ [type]: blob })];

      navigator.clipboard.write(data).then(
        function() {
          e.target.innerHTML = "Пароль скопирован";
        },
        function() {
          e.target.innerHTML = "Ошибка копирования";
        }
      );
    }
  },
  created() {}
};
</script>
